module.exports = __webpack_public_path__ + "img/arrow_right.208b2a84.svg";